<template>
    <div id="hqAssignBox">        
        <div class="searchWrap">
            <div class="row">
                <div class="itemWrap" v-if="divVisible" style="margin-right: 10px;">
                    <span class="datePickerClass">區處分行: </span>
                    <DivSelection v-model="selectedDeptID" :filterDivisionCode="filterDivisionCode" :style="{ width: '250px', marginLeft: '10px' }" />
                </div>
                <div class="itemWrap">
                    <span class="datePickerClass" >關鍵字: </span>
                    <el-input v-model.trim="keyword" placeholder="請輸入標籤關鍵字" clearable style="margin-left: 10px;width: 200px"></el-input>
                </div>
            </div>            
            <div class="row">
                <div class="itemWrap">                    
                    
                    <span class="datePickerClass">分析區間: </span>
                    <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="閞始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                    </el-date-picker>
                    
                                                              
                    <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                </div>
            </div>          
        </div>
        <div class="searchWrap" style="margin-top: 0px;">
            <div class="row3"  >                
                <div class="itemWrap" >
                    <el-button type="danger" icon="el-icon-plus" @click="exportXlS">匯出</el-button>          
                </div>                
            </div>            
        </div>     
        <div class="content" >
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">                            
              <el-table-column label="排名"  prop="Rank" min-width="20%">
              </el-table-column>                              
              <el-table-column label="關鍵字" prop="QueryContent"  min-width="60%">                
              </el-table-column>              
              <el-table-column label="次數"  prop="Count" min-width="20%"  >
              </el-table-column>                        
            </el-table>                
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists">
            </Pagination>
        </div>          

    </div>

    
</template>

<script>
import Breadcrumb from '../../components/Breadcrumb.vue';
import DivSelection from '../../components/DivSelection.vue';
import Pagination from '../../components/Pagination.vue';
import { notify, handleError } from '../../utils/notify.js';
import ExcelJS from 'exceljs';

export default {
    components: {DivSelection, Pagination},
    data() {
        return {
            keyword: "",
            tableData: [
            ],
            selectedDeptID: [],

            divVisible: false,

            dateRange: [],
            filterDivisionCode:'',

            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            totalLists:0,
            keyword: "",  

            listQuery: {
                "QueryType": "keyword",    // 共有tag, company, keyword三種                
                "DeptID": "",
                "StartDate": "",
                "EndDate": "",
                "QueryContent": "",
                "Page_Num": 1,
                "Page_Size": 10
            }, 


        }        

        
    },
    methods: {

        async exportXlS() {
            this.$store.dispatch("loadingHandler", true);

            let params = {
                "QueryType": "keyword",    // 共有tag, company, keyword三種
            };

            if( this.keyword && this.keyword.trim()!="" ) {
                params.QueryContent = this.keyword.trim();
            }

            if( Array.isArray(this.dateRange) && this.dateRange.length==2 ) {
                params.StartDate = this.dateRange[0].toISOString().split('T')[0];
                params.EndDate = this.dateRange[1].toISOString().split('T')[0];
            }

            if( !Array.isArray(this.selectedDeptID) || this.selectedDeptID.length==0 ) {
                
            }
            else {
                params.DeptID = this.selectedDeptID[1];
            }

            console.log("export params",params);

            await this.$api.apianalysis.userQueryStats_export(params).then(async res => {
                console.log("export res",res);
                if( res.statuscode==200 ) {
                    // 將 res.data 轉換為 Excel 格式
                    const excelData = res.data.map(item => ({
                        '排名': item.Rank,
                        '關鍵字': item.QueryContent,
                        '次數': item.Count
                    }));

                    const workbook = new ExcelJS.Workbook();
                    const worksheet = workbook.addWorksheet('關鍵字查詢統計');
                    worksheet.columns = [
                        { header: '排名', key: '排名', width: 12 },
                        { header: '關鍵字', key: '關鍵字', width: 40 },
                        { header: '次數', key: '次數', width: 12 }
                    ];
                    worksheet.addRows(excelData);

                    const excelBuffer = await workbook.xlsx.writeBuffer();
                    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                     
                    // 下載文件
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', '關鍵字查詢統計.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
                    const setAudit = {
                        "menu_path": ["客戶分析", "輸入關鍵字分析"],
                        "action_type": "export",
                        "action_name": "匯出",
                        "details": {                            
                            "exported_count": excelData.length
                        }
                    }
                    const resp = this.$api.apimgrs.setAuditLog(setAudit);    
                                        
                    notify({title: '成功', message: "匯出成功", type: 'success'});
                } else {
                    notify({title: '錯誤', message: "匯出失敗", type: 'error'});                    
                }
            }).catch( err => {
                notify({title: '錯誤', message: "匯出失敗", type: 'error'});                
            });

            this.$store.dispatch("loadingHandler", false);
        },

        async doSearch() {
            if( !Array.isArray(this.dateRange) || this.dateRange.length!=2 ) {
                notify({title: '提示', message: "請選擇分析區間", type: 'warning'});
                return;
            }
            this.listQuery.Page_Num = 1;
            await this.getList();
        },

        async getList() {
            this.$store.dispatch("loadingHandler", true);

            if( this.keyword && this.keyword.trim()!="" ) {
                this.listQuery.QueryContent = this.keyword.trim();
            } else {
                delete this.listQuery.QueryContent;
            }

            if( Array.isArray(this.dateRange) && this.dateRange.length==2 ) {
                this.listQuery.StartDate = this.dateRange[0].toISOString().split('T')[0];
                this.listQuery.EndDate = this.dateRange[1].toISOString().split('T')[0];
            } else {
                delete this.listQuery.StartDate;
                delete this.listQuery.EndDate;
            }

            if( !Array.isArray(this.selectedDeptID) || this.selectedDeptID.length==0 ) {
                delete this.listQuery.DeptID;
            }
            else {
                this.listQuery.DeptID = this.selectedDeptID[1];
            }

            console.log("listQuery",this.listQuery);

            await this.$api.apianalysis.userQueryStats(this.listQuery).then( res => {
                console.log("tagsHitList",res);
                if( res.data && res.statuscode==200 ) {
                    this.tableData = res.data;
                    this.totalLists = res.total;
                } else {
                    notify({title: '錯誤', message: "獲取標籤列表失敗", type: 'error'});                    
                }
            }).catch( err => {
                notify({title: '錯誤', message: "獲取標籤列表失敗", type: 'error'});                
            });


            this.$store.dispatch("loadingHandler", false);
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },  
        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },          
        
        getFunction() {
            const roleName = this.$store.getters.userRole;
            console.log('roleName:', roleName);
            if( roleName=="UC") {
                this.divVisible = false;
            } else {
                this.divVisible = true;
            }
            // 決定DivSelect元件顯示的層級
            if( roleName=="HE" || roleName=="HC1" ){
                const funs = this.$store.getters.userInfo;
                const branchArea = funs.DivisionCode;
                console.log('branchArea:', branchArea);
                this.filterDivisionCode = branchArea;
            }  

        }

    },    

    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        let today = new Date();
        // 預設為前一週（包含今日）：過去 7 天 
        let lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        this.dateRange = [lastWeek, today];
        this.totalLists = this.tableData.length;
        await this.getFunction();
        await this.getList();
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>

#hqAssignBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;


  .datePickerClass {
    margin-right: 10px;
    font-weight: bold;
  }

  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }
    }
    .row3 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;  
        width: 100%;
        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }      
  }


  .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        margin: 5px 0px;
        

        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;            
        }
        

    }
    .row3 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: flex-end;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }     
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    margin-top: 20px;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }
}
</style>